import React, { useEffect, useState } from "react";
import { Sparkles, Save, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api, { apiError, arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";

export default function AiPrompts() {
  const [prompts, setPrompts] = useState([]);
  const [savingKey, setSavingKey] = useState(null);

  useEffect(() => { api.get("/admin/ai-prompts").then(({ data }) => setPrompts(arr(data))); }, []);

  const update = (key, value) => setPrompts((p) => p.map((x) => (x.key === key ? { ...x, prompt: value } : x)));

  const save = async (p) => {
    setSavingKey(p.key);
    try {
      await api.put(`/admin/ai-prompts/${p.key}`, { prompt: p.prompt });
      toast.success(`${p.label} saved`);
    } catch (err) { toast.error(apiError(err)); } finally { setSavingKey(null); }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="AI Prompts" subtitle="Manage global prompts used for AI generation" icon={Sparkles} />
      <div className="space-y-5">
        {prompts.map((p) => (
          <div key={p.key} className="card-surface p-6">
            <div className="mb-3 flex items-center justify-between">
              <h3 className="font-heading text-base font-semibold text-slate-800">{p.label}</h3>
              <Button size="sm" onClick={() => save(p)} disabled={savingKey === p.key} className="rounded-xl bg-brand-700 text-white hover:bg-brand-800" data-testid={`save-prompt-${p.key}`}>
                {savingKey === p.key ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="mr-1 h-4 w-4" /> Save</>}
              </Button>
            </div>
            <textarea value={p.prompt} onChange={(e) => update(p.key, e.target.value)} rows={5} className="w-full rounded-xl border border-slate-200 bg-slate-50 p-3 text-sm outline-none focus:border-brand-400 focus:bg-white focus:ring-2 focus:ring-brand-200" />
            <p className="mt-2 text-xs text-slate-400">Use placeholders like {"{businessName}, {city}, {rating}, {reviewText}, {tone}, {language}"}.</p>
          </div>
        ))}
      </div>
    </div>
  );
}
